import Vue from "vue";
import VueRouter from "vue-router";
import store from "../store";
import { updatePageSeo } from "@/utils/seo";

//Admin
import AdminIndex from "@/components/admin/AdminIndex";
import AdminUpdate from "@/components/admin/AdminUpdate";
import AdminLogin from "@/components/admin/AdminLogin";
import AdminRegister from "@/components/admin/AdminRegister";
import ChangePassword from "@/components/admin/ChangePassword";
import ForgetPassword from "@/components/admin/ForgetPassword";
import ResetPassword from "@/components/admin/ResetPassword";

//Admin Category
import CategoryCreate from "@/components/admin/category/CategoryCreate";
import CategoryList from "@/components/admin/category/CategoryList";
import CategoryUpdate from "@/components/admin/category/CategoryUpdate";
import CategoryDetail from "@/components/admin/category/CategoryDetail";

//Admin Company
import CompanyCreate from "@/components/admin/company/CompanyCreate";
import CompanyList from "@/components/admin/company/CompanyList";
import CompanyUpdate from "@/components/admin/company/CompanyUpdate";
import CompanyDetail from "@/components/admin/company/CompanyDetail";

//Admin Job
import JobCreate from "@/components/admin/job/JobCreate";
import JobList from "@/components/admin/job/JobList";
import JobUpdate from "@/components/admin/job/JobUpdate";
import JobDetail from "@/components/admin/job/JobDetail";

//Admin Applicant
import AdminApplicantList from "@/components/admin/applicant/ApplicantList";
import AdminApplicantUpdate from "@/components/admin/applicant/ApplicantUpdate";
import AdminApplicantDetail from "@/components/admin/applicant/ApplicantDetail";

//Admin Resume
import AdminResumeDetail from "@/components/admin/resume/AdminResumeDetail";
import AdminResumeUpdate from "@/components/admin/resume/AdminResumeUpdate";

//Admin Job
import JobCompanyContact from "@/components/admin/job/JobCompanyContact";
import JobCompleteJob from "@/components/admin/job/JobCompleteJob";
import JobDeletedJob from "@/components/admin/job/JobDeletedJob";
import JobDetailStatus from "@/components/admin/job/JobDetailStatus";
import JobFinishedContact from "@/components/admin/job/JobFinishedContact";
import JobInvoiceJob from "@/components/admin/job/JobInvoiceJob";

//Company
import CompanyIndex from "@/components/company/CompanyIndex";
import CompanyIndexSearchResult from "@/components/company/CompanyIndexSearchResult";
import CompanyRegister from "@/components/company/CompanyRegister";
import CompanyLogin from "@/components/company/CompanyLogin";
import CompanyChangePassword from "@/components/company/CompanyChangePassword";
import CompanyForgetPassword from "@/components/company/CompanyForgetPassword";
import CompanyResetPassword from "@/components/company/CompanyResetPassword";
import JobPostCreate from "@/components/company/job_post/JobPostCreate";
import JobPostUpdate from "@/components/company/job_post/JobPostUpdate";
import JobPostIndex from "@/components/company/job_post/JobPostIndex";
import JobPostCategory from "@/components/company/job_post/JobPostCategory";
import JobPostJobDetail from "@/components/company/job_post/JobPostJobDetail";
import JobPostCompanyDetail from "@/components/company/job_post/JobPostCompanyDetail";
import CompanyDashboard from "@/components/company/CompanyDashboard";
import CompanyDashboardUpdate from "@/components/company/CompanyDashboardUpdate";
import CompanyJobRequest from "@/components/company/job_request/CompanyJobRequest";
import CompanyJobRequestDetail from "@/components/company/job_request/CompanyJobRequestDetail";
import CompanyResumeDetail from "@/components/company/CompanyResumeDetail";

//Applicant
import ApplicantIndex from "@/components/applicant/ApplicantIndex";
import ApplicantLogin from "@/components/applicant/ApplicantLogin";
import ApplicantRegister from "@/components/applicant/ApplicantRegister";
import ApplicantUpdate from "@/components/applicant/ApplicantUpdate";

import ApplicantResetPassword from "@/components/applicant/ApplicantResetPassword";
import ExpiredToken from "@/components/applicant/ExpiredToken";
import ApplicantForgetPassword from "@/components/applicant/ApplicantForgetPassword";
import ApplicantChangePassword from "@/components/applicant/ApplicantChangePassword";

//Home
import HomeIndex from "@/components/applicant/home/HomeIndex";
import JobCategory from "@/components/applicant/home/JobCategory";
import TermsOfService from "@/components/applicant/home/TermsOfService";
import PrivacyPolicy from "@/components/applicant/home/PrivacyPolicy";
import Policy from "@/components/applicant/home/Policy";
import JobRequest from "@/components/applicant/home/JobRequest";
import HomeIndexSearchResult from "@/components/applicant/home/HomeIndexSearchResult";

//Applicant Resume
import ResumeIndex from "@/components/applicant/resume/ResumeIndex";
import ResumeDetail from "@/components/applicant/resume/ResumeDetail";
import ResumeEdit from "@/components/applicant/resume/ResumeEdit";

import ContactUsCreate from "@/components/applicant/contact_us/ContactUsCreate";
import ContactUsNew from "@/components/applicant/contact_us/ContactUsNew";

//Apply
import ApplyIndex from "@/components/applicant/apply/ApplyIndex";
import ApplyJobDetail from "@/components/applicant/apply/ApplyJobDetail";

//Job Listing
import JobListingIndex from "@/components/applicant/job_listing/JobListingIndex";
import JobListingCompanyDetail from "@/components/applicant/job_listing/CompanyDetail";
import JobListingJobDetail from "@/components/applicant/job_listing/JobListingJobDetail";

//Job Request
import JobRequestCreate from "@/components/applicant/job_request/JobRequestCreate";
import JobRequestDetail from "@/components/applicant/job_request/JobRequestDetail";
import JobRequestUpdate from "@/components/applicant/job_request/JobRequestUpdate";

//Error
import InternalServerError from "@/components/error/InternalServerError";
import NotFound from "@/components/error/NotFound";

Vue.use(VueRouter);

const routes = [{
        path: "/admin/register",
        name: "adminRegister",
        component: AdminRegister,
        meta: {
            permission: 'admin'
        }
    },
    {
        path: "/admin/login",
        alias: "/admin",
        name: "adminLogin",
        component: AdminLogin,
    },
    {
        path: "/admin/index",
        name: "adminIndex",
        component: AdminIndex,
        meta: {
            permission: 'admin'
        }
    },
    {
        path: "/admin/update/:id",
        name: "adminUpdate",
        component: AdminUpdate,
        meta: {
            permission: 'admin'
        }
    },
    {
        path: "/admin/change_password/:id",
        name: "changePassword",
        component: ChangePassword,
        meta: {
            permission: 'admin'
        }
    },
    {
        path: "/admin/forget_password",
        name: "forgetPassword",
        component: ForgetPassword,
    },
    {
        path: "/admin/reset_password",
        name: "resetPassword",
        component: ResetPassword,
    },
    {
        path: "/admin/applicant/list",
        name: "adminApplicantList",
        component: AdminApplicantList,
        meta: {
            permission: 'admin'
        }
    },
    {
        path: "/admin/applicant/update/:id",
        name: "adminApplicantUpdate",
        component: AdminApplicantUpdate,
        meta: {
            permission: 'admin'
        }
    },
    {
        path: "/admin/applicant/detail/:id",
        name: "adminApplicantDetail",
        component: AdminApplicantDetail,
        meta: {
            permission: 'admin'
        }
    },

    //admin/category
    {
        path: "/admin/category/create",
        name: "categoryCreate",
        component: CategoryCreate,
        meta: {
            permission: 'admin'
        }
    },
    {
        path: "/admin/category/list",
        name: "categoryList",
        component: CategoryList,
        meta: {
            permission: 'admin'
        }
    },
    {
        path: "/admin/category/update/:id",
        name: "categoryUpdate",
        component: CategoryUpdate,
        meta: {
            permission: 'admin'
        }
    },
    {
        path: "/admin/category/detail/:id",
        name: "categoryDetail",
        component: CategoryDetail,
        meta: {
            permission: 'admin'
        }
    },

    //admin/company
    {
        path: "/admin/company/create",
        name: "companyCreate",
        component: CompanyCreate,
        meta: {
            permission: 'admin'
        }
    },
    {
        path: "/admin/company/list",
        name: "companyList",
        component: CompanyList,
        meta: {
            permission: 'admin'
        }
    },
    {
        path: "/admin/company/update/:id",
        name: "companyUpdate",
        component: CompanyUpdate,
        meta: {
            permission: 'admin'
        }
    },
    {
        path: "/admin/company/detail/:id",
        name: "companyDetail",
        component: CompanyDetail,
        meta: {
            permission: 'admin'
        }
    },

    //admin/job
    {
        path: "/admin/job/create",
        name: "jobCreate",
        component: JobCreate,
        meta: {
            permission: 'admin'
        }
    },
    {
        path: "/admin/job/list",
        name: "jobList",
        component: JobList,
        meta: {
            permission: 'admin'
        }
    },
    {
        path: "/admin/job/update/:id",
        name: "jobUpdate",
        component: JobUpdate,
        meta: {
            permission: 'admin'
        }
    },
    {
        path: "/admin/job/detail/:id",
        name: "jobDetail",
        component: JobDetail,
        meta: {
            permission: 'admin'
        }
    },

    {
        path: "/admin/job/company_contact/",
        name: "jobCompanyContact",
        component: JobCompanyContact,
        meta: {
            permission: 'admin'
        }
    },
    {
        path: "/admin/job/complete_job/",
        name: "jobCompleteJob",
        component: JobCompleteJob,
        meta: {
            permission: 'admin'
        }
    },
    {
        path: "/admin/job/deleted_job/",
        name: "jobDeletedJob",
        component: JobDeletedJob,
        meta: {
            permission: 'admin'
        }
    },
    {
        path: "/admin/job/detail_status/:id",
        name: "jobDetailStatus",
        component: JobDetailStatus,
        meta: {
            permission: 'admin'
        }
    },
    {
        path: "/admin/job/finished_contact/",
        name: "jobFinishedContact",
        component: JobFinishedContact,
        meta: {
            permission: 'admin'
        }
    },
    {
        path: "/admin/job/invoice_job/",
        name: "jobInvoiceJob",
        component: JobInvoiceJob,
        meta: {
            permission: 'admin'
        }
    },
    {
        path: "/admin/resume/detail/:id",
        name: "adminResumeDetail",
        component: AdminResumeDetail,
        meta: {
            permission: 'admin'
        }
    },
    {
        path: "/admin/resume/edit/:id",
        name: "adminResumeUpdate",
        component: AdminResumeUpdate,
        meta: {
            permission: 'admin'
        }
    },

    //company
    {
        path: "/company/index",
        name: "companyIndex",
        component: CompanyIndex,
        meta: {
            title: "ကုမ္ပဏီ ပင်မစာမျက်နှာ"
        }
    },
    {
        path: "/company/search/result",
        name: "companyIndexSearchResult",
        component: CompanyIndexSearchResult,
        meta: {
            title: "အလုပ်ရှာဖွေမှု ရလဒ်များ"
        }
    },
    {
        path: "/company/register",
        name: "companyRegister",
        component: CompanyRegister,
        props: true,
        meta: {
            title: "ကုမ္ပဏီ အကောင့်ဖွင့်ရန်"
        }
    },
    {
        path: "/company/login",
        alias: "/company",
        name: "companyLogin",
        component: CompanyLogin,
        meta: {
            title: "ကုမ္ပဏီ အကောင့်ဝင်ရန်"
        }
    },
    {
        path: "/company/change_password/:id",
        name: "companyChangePassword",
        component: CompanyChangePassword,
        meta: {
            permission: 'company',
            title: "စကားဝှက် ပြောင်းလဲရန်"
        }
    },
    {
        path: "/company/forget_password",
        name: "companyForgetPassword",
        component: CompanyForgetPassword,
        meta: {
            title: "စကားဝှက် မေ့နေပါသလား"
        }
    },
    {
        path: "/company/reset_password",
        name: "companyResetPassword",
        component: CompanyResetPassword,
        meta: {
            title: "စကားဝှက် ပြန်လည်သတ်မှတ်ရန်"
        }
    },
    {
        path: "/company/job/create",
        name: "jobPostCreate",
        component: JobPostCreate,
        meta: {
            permission: 'company',
            title: "အလုပ်ခေါ်ယူမှု အသစ်တင်ရန်"
        }
    },
    {
        path: "/company/job/update/:id",
        name: "jobPostUpdate",
        component: JobPostUpdate,
        meta: {
            permission: 'company',
            title: "အလုပ်ခေါ်ယူမှု ပြင်ဆင်ရန်"
        }
    },
    {
        path: "/company/dashboard/:id",
        name: "companyDashboard",
        component: CompanyDashboard,
        meta: {
            permission: 'company',
            title: "ကုမ္ပဏီ"
        }
    },
    {
        path: "/company/dashboard/update/:id",
        name: "companyDashboardUpdate",
        component: CompanyDashboardUpdate,
        meta: {
            permission: 'company',
            title: "ကုမ္ပဏီ အချက်အလက် ပြင်ဆင်ရန်"
        }
    },
    {
        path: "/company/job_post/index/:id",
        name: "jobPostIndex",
        component: JobPostIndex,
        meta: {
            title: "အလုပ်အကိုင်များ"
        }
    },
    {
        path: "/company/job_post/category",
        name: "jobPostCategory",
        component: JobPostCategory,
        meta: {
            title: "အလုပ်အကိုင် အမျိုးအစားများ"
        }
    },
    {
        path: "/company/job_post/job_detail/:id",
        name: "jobPostJobDetail",
        component: JobPostJobDetail,
        meta: {
            title: "အလုပ်အကိုင် အသေးစိတ်"
        }
    },
    {
        path: "/company/job_post/company_detail/:id",
        name: "jobPostCompanyDetail",
        component: JobPostCompanyDetail,
        meta: {
            title: "ကုမ္ပဏီ အချက်အလက်များ"
        }
    },
    {
        path: "/company/job_request",
        name: "companyJobRequest",
        component: CompanyJobRequest,
        meta: {
            title: "အလုပ်ရှာ ဖွေမှု ပို့စ်များ"
        }
    },
    {
        path: "/company/job_request/detail/:id",
        name: "companyJobRequestDetail",
        component: CompanyJobRequestDetail,
        meta: {
            title: "အလုပ်ရှာ ပို့စ် အသေးစိတ်"
        }
    },
    {
        path: "/company/resume/detail/:id",
        name: "companyResumeDetail",
        component: CompanyResumeDetail,
        meta: {
            title: "ကိုယ်ရေးရာဇဝင် အသေးစိတ်"
        }
    },

    //apply
    {
        path: "/apply/index/:id",
        name: "applyIndex",
        component: ApplyIndex,
        meta: {
            title: "အလုပ်လျှောက်ထားရန်"
        }
    },
    {
        path: "/apply/job_detail/:id",
        name: "applyJobDetail",
        component: ApplyJobDetail,
        meta: {
            title: "အလုပ်လျှောက်ထားမှု အသေးစိတ်"
        }
    },

    //job listing
    {
        path: "/job_listing/index/:id",
        name: "jobListingIndex",
        component: JobListingIndex,
        meta: {
            title: "အလုပ်အကိုင်များ ရှာဖွေလျှောက်ထားရန် | Latest Jobs in Myanmar",
            description: "မြန်မာနိုင်ငံတစ်ဝှမ်းရှိ အချိန်ပြည့်၊ အချိန်ပိုင်းနှင့် Remote အလုပ်အကိုင်များကို ရှာဖွေလျှောက်ထားပါ။ Find full-time, part-time and remote jobs in Myanmar."
        }
    },
    {
        path: "/job_listing/company_detail/:id",
        name: "jobListingCompanyDetail",
        component: JobListingCompanyDetail,
        meta: {
            title: "ကုမ္ပဏီ အချက်အလက်နှင့် အလုပ်အကိုင်များ | Company Profiles",
            description: "ကုမ္ပဏီအချက်အလက်များနှင့် လက်ရှိခေါ်ယူနေသော အလုပ်အကိုင်အခွင့်အလမ်းများကို ကြည့်ရှုပါ။ View company details and active job openings in Myanmar."
        }
    },
    {
        path: "/job_listing/job_detail/:id",
        name: "jobListingJobDetail",
        component: JobListingJobDetail,
        meta: {
            title: "အလုပ်အကိုင် အသေးစိတ် | Job Details",
            description: "အလုပ်အကိုင် အသေးစိတ်အချက်အလက်များ၊ လစာနှင့် လိုအပ်ချက်များကို ကြည့်ရှုပြီး ချက်ချင်း လျှောက်ထားပါ။"
        }
    },

    //applicant
    {
        path: "/applicant/index",
        name: "applicantIndex",
        component: ApplicantIndex,
        meta: {
            permission: 'applicant',
            title: "ကိုယ်ပိုင် အချက်အလက်"
        }
    },
    {
        path: "/applicant/login",
        name: "applicantLogin",
        component: ApplicantLogin,
        meta: {
            title: "အကောင့်ဝင်ရန် | Applicant Login"
        }
    },
    {
        path: "/applicant/register",
        name: "applicantRegister",
        component: ApplicantRegister,
        props: true,
        meta: {
            title: "အကောင့်ဖွင့်ရန် | Applicant Register"
        }
    },
    {
        path: "/applicant/edit/:id",
        name: "applicantUpdate",
        component: ApplicantUpdate,
        meta: {
            permission: 'applicant',
            title: "ကိုယ်ရေးအချက်အလက် ပြင်ဆင်ရန်"
        }
    },
    {
        path: "/applicant/forget_password",
        name: "applicantForgetPassword",
        component: ApplicantForgetPassword,
        meta: {
            title: "စကားဝှက် မေ့နေပါသလား"
        }
    },
    {
        path: "/applicant/reset_password",
        name: "applicantResetPassword",
        component: ApplicantResetPassword,
        meta: {
            title: "စကားဝှက် ပြန်လည်သတ်မှတ်ရန်"
        }
    },
    {
        path: "/expired_token",
        name: "expiredToken",
        component: ExpiredToken,
        meta: {
            title: "သက်တမ်းကုန်သွားပါပြီ"
        }
    },
    {
        path: "/applicant/change_password/:id",
        name: "applicantChangePassword",
        component: ApplicantChangePassword,
        meta: {
            permission: 'applicant',
            title: "စကားဝှက် ပြောင်းလဲရန်"
        }
    },
    //job request 
    {
        path: "/applicant/job_request/create",
        name: "jobRequestCreate",
        component: JobRequestCreate,
        meta: {
            permission: 'applicant',
            title: "အလုပ်ရှာ ပို့စ်တင်ရန်"
        }
    },
    {
        path: "/applicant/job_request/detail/:id",
        name: "jobRequestDetail",
        component: JobRequestDetail,
        meta: {
            title: "အလုပ်ရှာ ပို့စ် အသေးစိတ်"
        }
    },
    {
        path: "/applicant/job_request/update/:id",
        name: "jobRequestUpdate",
        component: JobRequestUpdate,
        meta: {
            permission: 'applicant',
            title: "အလုပ်ရှာ ပို့စ် ပြင်ဆင်ရန်"
        }
    },

    //home
    {
        path: "/",
        name: "homeIndex",
        component: HomeIndex,
        meta: {
            title: "BIB JOB - မြန်မာနိုင်ငံရှိ အကောင်းဆုံး အလုပ်အကိုင်များ ရှာဖွေရန် | Best Jobs in Myanmar",
            description: "မြန်မာနိုင်ငံရှိ ထိပ်တန်းကုမ္ပဏီများမှ အလုပ်အကိုင်အခွင့်အလမ်းများကို အခမဲ့ ရှာဖွေလျှောက်ထားလိုက်ပါ။ Search, apply, and get hired today at BIB JOB."
        }
    },
    {
        path: "/search/result",
        name: "homeIndexSearchResult",
        component: HomeIndexSearchResult,
        meta: {
            title: "အလုပ် ရှာဖွေမှု ရလဒ်များ | Search Results",
            description: "BIB JOB တွင် မိမိနှင့် ကိုက်ညီသော အလုပ်အကိုင် ရာထူးများကို ရှာဖွေတွေ့ရှိပါ။"
        }
    },
    {
        path: "/contact_us/create",
        name: "contactUsCreate",
        component: ContactUsCreate,
        meta: {
            title: "ဆက်သွယ်ရန် | Contact Us",
            description: "BIB JOB အဖွဲ့သားများထံ ဆက်သွယ်မေးမြန်း စုံစမ်းရန်။"
        }
    },
    {
        path: "/contact_us/new",
        name: "contactUsNew",
        component: ContactUsNew,
        meta: {
            title: "ဆက်သွယ်ရန် | Contact Us",
            description: "BIB JOB အဖွဲ့သားများထံ ဆက်သွယ်မေးမြန်း စုံစမ်းရန်။"
        }
    },
    {
        path: "/home/job_category",
        name: "jobCategory",
        component: JobCategory,
        meta: {
            title: "အလုပ်အကိုင် အမျိုးအစားများ | Job Categories in Myanmar",
            description: "IT၊ အရောင်း၊ စီမံခန့်ခွဲမှု၊ အင်ဂျင်နီယာ အစရှိသော ကဏ္ဍအလိုက် အလုပ်အကိုင်များကို လွယ်ကူစွာ ရှာဖွေပါ။ Browse all job categories in Myanmar."
        }
    },
    {
        path: "/home/terms_of_service",
        name: "termsOfService",
        component: TermsOfService,
        meta: {
            title: "ဝန်ဆောင်မှု စည်းကမ်းချက်များ | Terms of Service",
            description: "BIB JOB အသုံးပြုသူများအတွက် ဝန်ဆောင်မှု စည်းမျဉ်းနှင့် စည်းကမ်းချက်များ။"
        }
    },
    {
        path: "/home/privacy_policy",
        name: "privacyPolicy",
        component: PrivacyPolicy,
        meta: {
            title: "ကိုယ်ရေးအချက်အလက် မူဝါဒ | Privacy Policy",
            description: "BIB JOB ၏ အသုံးပြုသူ ကိုယ်ရေးအချက်အလက် လုံခြုံမှုဆိုင်ရာ မူဝါဒ။"
        }
    },
    {
        path: "/policy",
        name: "policy",
        component: Policy,
        meta: {
            title: "မူဝါဒနှင့် စည်းကမ်းချက်များ | Policies"
        }
    },
    {
        path: "/home/job_request",
        name: "jobRequest",
        component: JobRequest,
        meta: {
            title: "အလုပ်ရှာ ဖွေမှု ပို့စ်များ | Job Requests & Candidate Profiles",
            description: "အလုပ်ရှာဖွေနေသူများ၏ ကိုယ်ရေးအချက်အလက်များနှင့် အလုပ်ရှာဖွေမှု ပို့စ်များကို ရှာဖွေလေ့လာပါ။ Explore job requests and candidate CVs in Myanmar."
        }
    },
    {
        path: "/resume",
        name: "resumeIndex",
        component: ResumeIndex,
        meta: {
            permission: 'applicant',
            title: "ကိုယ်ရေးရာဇဝင် (CV)"
        }
    },
    {
        path: "/resume/detail/:id",
        name: "resumeDetail",
        component: ResumeDetail,
        meta: {
            permission: 'applicant',
            title: "ကိုယ်ရေးရာဇဝင် အသေးစိတ်"
        }
    },
    {
        path: "/resume/edit/:id",
        name: "resumeEdit",
        component: ResumeEdit,
        meta: {
            permission: 'applicant',
            title: "ကိုယ်ရေးရာဇဝင် ပြင်ဆင်ရန်"
        }
    },
    {
        path: "/error/internal_server_error",
        name: "internalServerError",
        component: InternalServerError,
    },
    {
        path: "/error/not_found",
        name: "notFound",
        component: NotFound,
    },
    {
        path: "*",
        component: NotFound,
    },
];

const router = new VueRouter({
    mode: "history",
    routes,
});

router.beforeEach((to, from, next) => {
    const adminLoggedIn = store.getters.isAdminLoggedIn;
    const applicantLoggedIn = store.getters.isApplicantLoggedIn;
    const companyLoggedIn = store.getters.isCompanyLoggedIn;
    switch (to.meta.permission) {
        case 'admin':
            if (!adminLoggedIn && to.name != "adminLogin") {
                return next("/admin/login");
            } else { 
                next();
            }

            break;

        case 'applicant':
            if (!applicantLoggedIn && to.name != "applicantLogin") {
                return next("/applicant/login");
            } else {
                next();
            }
            break;

        case 'company':
            if (!companyLoggedIn && to.name != "companyLogin") {
                return next("/company/login");
            } else {
                next();
            }
            break;    

        default:
            next();
    }
});

router.afterEach((to, from) => {
    if (typeof document !== "undefined") {
        updatePageSeo({
            title: to.meta && to.meta.title,
            description: to.meta && to.meta.description
        });

        const isAdminPage = to.path.startsWith("/admin");
        const wasAdminPage = from.path.startsWith("/admin");

        if (isAdminPage && !wasAdminPage) {
            if (!document.getElementById("admin-styles")) {
                const link = document.createElement("link");
                link.id = "admin-styles";
                link.rel = "stylesheet";
                link.href = "/css/admin/admin_style.css";
                document.head.appendChild(link);
            }
        } else if (!isAdminPage && wasAdminPage) {
            const link = document.getElementById("admin-styles");
            if (link) {
                link.remove();
            }
        }
    }
});

export default router;
